import { createApiActionTypes } from 'store';

// results action types
export const GET_SURVEY_ROUND_LIST = createApiActionTypes(
	'GET_SURVEY_ROUND_LIST',
);
export const GET_EMPLOYEE_LIST = createApiActionTypes('GET_EMPLOYEE_LIST');
export const RESET_EMPLOYEE_LIST = 'RESET_EMPLOYEE_LIST';
export const GET_SHORT_CLIENT_LIST = createApiActionTypes(
	'GET_SHORT_CLIENT_LIST',
);
export const UPDATE_DASHBOARD_CLIENT_LIST = createApiActionTypes(
	'UPDATE_DASHBOARD_CLIENT_LIST',
);

// comment action types
export const GET_COMMENT = createApiActionTypes('GET_COMMENT');
export const GET_COMMENT_AVERAGE = createApiActionTypes('GET_COMMENT_AVERAGE');
export const GET_MARKS_FOR_EMPLOYER = createApiActionTypes(
	'GET_MARKS_FOR_EMPLOYER',
);
export const RESET_MARKS_FOR_EMPLOYER = 'RESET_MARKS_FOR_EMPLOYER';
export const GET_ALL_RELATED_COMMENTS = createApiActionTypes(
	'GET_ALL_RELATED_COMMENTS',
);
export const GET_COMPARE_COMMENTS = createApiActionTypes(
	'GET_COMPARE_COMMENTS',
);
export const RESET_COMMENT_LIST = 'RESET_COMMENT_LIST';
export const SET_COMMENTS_COMMENT_TYPE = 'SET_SERVICE_COMMENT_TYPE';
export const RESET_COMMENTS_TYPE = 'RESET_COMMENTS_TYPE';
export const RESET_COMPARED_COMMENTS = 'RESET_COMPARED_COMMENTS';

export const GET_DASHBOARD_COMMENTS = createApiActionTypes(
	'GET_DASHBOARD_COMMENTS',
);
export const GET_DASHBOARD_COMMENTS_WORDCLOUD = createApiActionTypes(
	'GET_DASHBOARD_COMMENTS_WORDCLOUD',
);
export const RESET_DASHBOARD_COMMENTS = 'RESET_DASHBOARD_COMMENTS';
export const SET_ACTIVE_DASHBOARD_COMMENT_TYPE =
	'SET_ACTIVE_DASHBOARD_COMMENT_TYPE';
export const GET_SURVEY_RESULTS = createApiActionTypes('GET_SURVEY_RESULTS');
export const GET_DASHBOARD_CONTENT = createApiActionTypes(
	'GET_DASHBOARD_CONTENT',
);
export const GET_DASHBOARD_ROUNDS_LIST = createApiActionTypes(
	'GET_DASHBOARD_ROUNDS_LIST',
);
export const SET_DASHBOARD_ACTIVE_ROUND = 'SET_DASHBOARD_ACTIVE_ROUND';
export const GET_DASHBOARD_ROUND_DATA = createApiActionTypes(
	'GET_DASHBOARD_ROUND_DATA',
);
export const GET_DASHBOARD_SERVICES_LIST = createApiActionTypes(
	'GET_DASHBOARD_SERVICES_LIST',
);
export const SET_DASHBOARD_ACTIVE_SERVICE = 'SET_DASHBOARD_ACTIVE_SERVICE';
export const GET_DASHBOARD_ROLES_LIST = createApiActionTypes(
	'GET_DASHBOARD_ROLES_LIST',
);
export const SET_DASHBOARD_ACTIVE_ROLE = 'SET_DASHBOARD_ACTIVE_ROLE';
export const GET_DASHBOARD_BUSINESS_UNIT_LIST = createApiActionTypes(
	'GET_DASHBOARD_BUSINESS_UNIT_LIST',
);
export const SET_DASHBOARD_ACTIVE_BUSINESS_UNIT =
	'SET_DASHBOARD_ACTIVE_BUSINESS_UNIT';
export const SET_IS_LOCATION_CHANGED = 'SET_IS_LOCATION_CHANGED';
export const GET_DASHBOARD_TRENDS_LIST = createApiActionTypes(
	'GET_DASHBOARD_TRENDS_LIST',
);
export const GET_DASHBOARD_COMPARE_TRENDS_LIST = createApiActionTypes(
	'GET_DASHBOARD_COMPARE_TRENDS_LIST',
);
export const GET_DASHBOARD_MAP_DATA = createApiActionTypes(
	'GET_DASHBOARD_MAP_DATA',
);
export const GET_DASHBOARD_REGIONS = createApiActionTypes(
	'GET_DASHBOARD_REGIONS',
);
export const GET_DASHBOARD_SERVICE_CARDS = createApiActionTypes(
	'GET_DASHBOARD_SERVICE_CARDS',
);
export const SET_DASHBOARD_ACTIVE_LOCATION = 'SET_DASHBOARD_ACTIVE_LOCATION';
export const GET_DASHBOARD_REPORT = createApiActionTypes(
	'GET_DASHBOARD_REPORT',
);
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA';
export const RESET_FILTERS_TO_RESET = 'RESET_FILTERS_TO_RESET';

export const GET_ALL_COMMENTS_DATA = createApiActionTypes(
	'GET_ALL_COMMENTS_DATA',
);
export const GET_SERVICE_STATS = createApiActionTypes('GET_SERVICE_STATS');

// persona
export const GET_PERSONA_LIST = createApiActionTypes('GET_PERSONA_LIST');
export const GET_PERSONA_DETAILS = createApiActionTypes('GET_PERSONA_DETAILS');
export const RESET_PERSONA_DETAILS = 'RESET_PERSONA_DETAILS';
export const GET_PERSONA_TRENDS = createApiActionTypes('GET_PERSONA_TRENDS');
export const GET_PERSONA_TYPICAL_ROLES = createApiActionTypes(
	'GET_PERSONA_TYPICAL_ROLES',
);
export const GET_PERSONA_SATISFACTION = createApiActionTypes(
	'GET_PERSONA_SATISFACTION',
);
export const GET_PERSONA_COMMENTS = createApiActionTypes(
	'GET_PERSONA_COMMENTS',
);
export const GET_PERSONA_COMMENTS_WORDCLOUD = createApiActionTypes(
	'GET_PERSONA_COMMENTS_WORDCLOUD',
);
export const SET_PERSONA_ACTIVE_COMMENT_TYPE =
	'SET_PERSONA_ACTIVE_COMMENT_TYPE';

export const GET_RANGE_DATA = createApiActionTypes('GET_RANGE_DATA');
export const GET_ROUNDS = createApiActionTypes('GET_ROUNDS');

export const SET_ACTIVE_SERVICE_EXAMPLES = 'SET_ACTIVE_SERVICE_EXAMPLES';

// quick survey requests
export const GET_NPS_TRENDS = createApiActionTypes('GET_NPS_TRENDS');
export const GET_QUICK_QUESTION_ANSWERS = createApiActionTypes(
	'GET_QUICK_QUESTION_ANSWERS',
);
export const SET_ACTIVE_DASHBOARD_ANSWERS_TYPE =
	'SET_ACTIVE_DASHBOARD_ANSWERS_TYPE';
export const GET_QUICK_QUESTION_ANSWERS_WORDCLOUD = createApiActionTypes(
	'GET_QUICK_QUESTION_ANSWERS_WORDCLOUD',
);
export const GET_STATISTIC = createApiActionTypes('GET_STATISTIC');

// MAP ACTIONS
export const SET_ZOOM_TYPE_INDEX = 'SET_ZOOM_TYPE_INDEX';
export const GET_MATCHED_LOCATIONS = createApiActionTypes(
	'GET_MATCHED_LOCATIONS',
);
export const RESET_MATCHED_LOCATIONS = 'RESET_MATCHED_LOCATIONS';
export const SET_IS_LOCATION_SEARCH_FOR_OFFICE =
	'SET_IS_LOCATION_SEARCH_FOR_OFFICE';
export const RESET_IS_LOCATION_SEARCH_FOR_OFFICE =
	'RESET_IS_LOCATION_SEARCH_FOR_OFFICE';

// EXECUTIVE SUMMARY PAGE
export const GET_ALL_SUMMARY_DATA = createApiActionTypes(
	'GET_ALL_SUMMARY_DATA',
);
export const GET_SUMMARY_ROUNDS = createApiActionTypes('GET_SUMMARY_ROUNDS');
export const GET_SUMMARY_SERVICE_CARDS = createApiActionTypes(
	'GET_SUMMARY_SERVICE_CARDS',
);
export const GET_SUMMARY_HEATMAP_STATISTIC = createApiActionTypes(
	'GET_SUMMARY_HEATMAP_STATISTIC',
);
export const GET_SUMMARY_SERVICE_LIST = createApiActionTypes(
	'GET_SUMMARY_SERVICE_LIST',
);
export const GET_CLIENT_LOGO = createApiActionTypes('GET_CLIENT_LOGO');
export const GET_SUMMARY_METRICS = createApiActionTypes('GET_SUMMARY_METRICS');
export const RESET_ERRORS = 'RESET_ERRORS';
